// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"c5f14c05","151":"c6aa27ec","275":"f770fb2f","415":"6298005d","493":"87c16306","824":"aa7ef0b0"}[chunkId] + ".chunk.js";
};